import { render, staticRenderFns } from "./ProductInfoFixedHeader.vue?vue&type=template&id=676692f2&scoped=true&"
import script from "./ProductInfoFixedHeader.vue?vue&type=script&lang=js&"
export * from "./ProductInfoFixedHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoFixedHeader.vue?vue&type=style&index=0&id=676692f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676692f2",
  null
  
)

export default component.exports